__turbopack_context__.v({
  "arrow-icon": "SearchCombobox-module-scss-module__SEVFKW__arrow-icon",
  "clear-button": "SearchCombobox-module-scss-module__SEVFKW__clear-button",
  "close-icon": "SearchCombobox-module-scss-module__SEVFKW__close-icon",
  "content": "SearchCombobox-module-scss-module__SEVFKW__content",
  "control": "SearchCombobox-module-scss-module__SEVFKW__control",
  "delete-button": "SearchCombobox-module-scss-module__SEVFKW__delete-button",
  "fade-in-slide-up": "SearchCombobox-module-scss-module__SEVFKW__fade-in-slide-up",
  "fade-out-slide-down": "SearchCombobox-module-scss-module__SEVFKW__fade-out-slide-down",
  "input": "SearchCombobox-module-scss-module__SEVFKW__input",
  "item": "SearchCombobox-module-scss-module__SEVFKW__item",
  "item-arrow": "SearchCombobox-module-scss-module__SEVFKW__item-arrow",
  "item-text": "SearchCombobox-module-scss-module__SEVFKW__item-text",
  "item-wrapper": "SearchCombobox-module-scss-module__SEVFKW__item-wrapper",
  "label-wrapper": "SearchCombobox-module-scss-module__SEVFKW__label-wrapper",
  "magnifying-glass": "SearchCombobox-module-scss-module__SEVFKW__magnifying-glass",
  "recent-searches-item": "SearchCombobox-module-scss-module__SEVFKW__recent-searches-item",
  "recent-searches-label": "SearchCombobox-module-scss-module__SEVFKW__recent-searches-label",
  "trigger": "SearchCombobox-module-scss-module__SEVFKW__trigger",
});
